import { Entity } from "@backstage/catalog-model";
import {
	createApiFactory,
	createComponentExtension,
	createPlugin,
	createRoutableExtension,
	discoveryApiRef,
	fetchApiRef,
} from "@backstage/core-plugin-api";

import { ArgoWorkflowsClient, argoWorkflowsApiRef } from "./api";
import { rootRouteRef } from "./routes";

export const ARGO_WORKFLOWS_LABEL_SELECTOR_ANNOTATION =
	"argo-workflows.cnoe.io/label-selector";
export const ARGO_WORKFLOWS_NAMESPACE_ANNOTATION =
	"argo-workflows.cnoe.io/namespace";
export const ARGO_WORKFLOWS_CLUSTER_NAME_ANNOTATION =
	"argo-workflows.cnoe.io/cluster-name";

export const isArgoWorkflowsAvailable = (entity: Entity): boolean =>
	Boolean(
		entity.metadata.annotations?.[ARGO_WORKFLOWS_LABEL_SELECTOR_ANNOTATION],
	);

export const argoWorkflowsPlugin = createPlugin({
	id: "argo-workflows",
	apis: [
		createApiFactory({
			api: argoWorkflowsApiRef,
			deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
			factory: ({ discoveryApi, fetchApi }) =>
				new ArgoWorkflowsClient({ discoveryApi, fetchApi }),
		}),
	],
	routes: {
		root: rootRouteRef,
	},
});

export const EntityArgoWorkflowsContent = argoWorkflowsPlugin.provide(
	createRoutableExtension({
		name: "EntityArgoWorkflowsContent",
		component: () =>
			import("./components/EntityArgoWorkflowsContent").then(
				(m) => m.EntityArgoWorkflowsContent,
			),
		mountPoint: rootRouteRef,
	}),
);

export const EntityArgoWorkflowsTemplatesCard = argoWorkflowsPlugin.provide(
	createComponentExtension({
		name: "EntityArgoWorkflowsTemplatesCard",
		component: {
			lazy: () =>
				import("./components/WorkflowTemplatesCard").then(
					(m) => m.WorkflowTemplatesCard,
				),
		},
	}),
);
